/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	rowWithDescription: {
		width: 'fit-content',
		paddingTop: token('space.100'),
		paddingRight: token('space.100'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.100'),
		display: 'grid',
		columnGap: token('space.100'),
		gridTemplateColumns: 'auto 1fr',
		gridTemplateAreas: `
		"icon title"
		"icon description"
	`,
		alignItems: 'center',
		height: '50px',
		borderRadius: token('radius.large'),
	},
	icon: {
		gridArea: 'icon',
		backgroundColor: token('color.background.neutral'),
		width: '24px',
		height: '24px',
		borderRadius: token('radius.xsmall'),
	},
	title: {
		gridArea: 'title',
		backgroundColor: token('color.background.neutral'),
		width: '260px',
		height: '14px',
		borderRadius: token('radius.xsmall'),
	},
	description: {
		gridArea: 'description',
		backgroundColor: token('color.background.neutral'),
		width: '150px',
		height: '10px',
		borderRadius: token('radius.xsmall'),
	},
});

export const RowSkeleton = (): JSX.Element => {
	return (
		<Box xcss={styles.rowWithDescription}>
			<Box xcss={styles.icon} />
			<Box xcss={styles.title} />
			<Box xcss={styles.description} />
		</Box>
	);
};
